import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Connection, ConnectionAvatar, ConnectionName } from './styles';

class ConnectionUser extends Component {
  handleClick = () => {
    const { onClick, connection: { id } } = this.props;

    onClick(id);
  }

  render() {
    const { connection } = this.props;
    return (
      <Connection onClick={this.handleClick}>
        {connection.avatar !== '' ? (
          <ConnectionAvatar alt={connection.firstname} src={connection.avatar} />
        ) : (
          <ConnectionAvatar className='text-avatar'>
            {connection.firstname.slice(0, 1)}
          </ConnectionAvatar>
        )}

        <ConnectionName>
          {`${connection.firstname} ${connection.lastname}`}
        </ConnectionName>
      </Connection>
    );
  }
}

ConnectionUser.propTypes = {
  connection: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ConnectionUser;



// WEBPACK FOOTER //
// ./src/routes/Connections/components/ConnectionUser.jsx